import { Box } from '@mui/material';
import React, { useState, useRef } from 'react';
import AnimatedButton from '../../AnimatedButton/AnimatedButton';

type IAddMediaButtonProps = {
  handleFileSelect: (_fileIndex: number, _event: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputKey: number;
};

function AddMediaTray({ handleFileSelect, fileInputKey }: IAddMediaButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [displayButtons, setDisplayButtons] = useState(false);

  const imageInputRef = useRef<HTMLInputElement | null>(null);
  const audioInputRef = useRef<HTMLInputElement | null>(null);
  const videoInputRef = useRef<HTMLInputElement | null>(null);
  // const documentInputRef = useRef<HTMLInputElement | null>(null);

  // Trigger a click event on the hidden file inputs
  const triggerImageSelect = () => {
    imageInputRef.current?.click();
  };

  // Trigger a click event on the hidden file inputs
  const triggerAudioSelect = () => {
    audioInputRef.current?.click();
  };

  const triggerVideoSelect = () => {
    videoInputRef.current?.click();
  };

  // const triggerDocumentSelect = () => {
  //   documentInputRef.current?.click();
  // };

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-start" mt="5px" mr="5px">
      <Box
        onClick={() => {
          if (isOpen) {
            setIsOpen(false);
            setDisplayButtons(false);
          } else {
            setIsOpen(true);
            setDisplayButtons(true);
          }
        }}
        sx={{
          cursor: 'pointer',
        }}
      >
        <img
          src={isOpen ? '/assets/icons/note-close.svg' : '/assets/icons/note-plus.svg'}
          alt="toggle-options"
          style={{ width: '20px', height: '20px' }}
        />
      </Box>

      {displayButtons && (
        <Box display="flex" ml="10px" bgcolor="" gap="10px">
          <AnimatedButton open={isOpen} onClick={triggerImageSelect}>
            <input
              data-testid="image-input"
              type="file"
              accept="image/*"
              ref={imageInputRef}
              onChange={(e) => handleFileSelect(fileInputKey, e)}
              style={{ display: 'none' }}
              key={fileInputKey}
            />
            <img
              src="/assets/icons/note-img.svg"
              alt="add-img"
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer',
              }}
            />
          </AnimatedButton>

          <AnimatedButton open={isOpen} onClick={triggerAudioSelect}>
            <input
              id="audioInput"
              type="file"
              accept="audio/*"
              ref={audioInputRef}
              onChange={(e) => handleFileSelect(fileInputKey, e)}
              style={{ display: 'none' }}
              key={fileInputKey}
            />
            <img
              src="/assets/icons/music.svg"
              alt="add-link"
              style={{ width: '20px', height: '20px', cursor: 'pointer' }}
            />
          </AnimatedButton>
          <AnimatedButton open={isOpen} onClick={triggerVideoSelect}>
            <input
              data-testid="video-input"
              type="file"
              accept="video/*"
              ref={videoInputRef}
              onChange={(e) => handleFileSelect(fileInputKey, e)}
              style={{ display: 'none' }}
              key={`video-${fileInputKey}`}
            />
            <img
              src="/assets/icons/video-frame.svg"
              alt="add-video"
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer',
              }}
            />
          </AnimatedButton>
          {/* <AnimatedButton open={isOpen} onClick={triggerDocumentSelect} > */}
          {/*   <input */}
          {/*     data-testid="document-upload" */}
          {/*     type="file" */}
          {/*     accept=".pdf,.doc,.docx,.xls,.xlsx" */}
          {/*     ref={documentInputRef} */}
          {/*     onChange={(e) => handleFileSelect(fileInputKey, e)} */}
          {/*     style={{ display: 'none' }} */}
          {/*     key={`document-${fileInputKey}`} */}
          {/*   /> */}
          {/*   <img */}
          {/*     src="/assets/icons/document-upload.svg" */}
          {/*     alt="add-document" */}
          {/*     style={{ */}
          {/*       width: '20px', */}
          {/*       height: '20px', */}
          {/*       cursor: 'pointer', */}
          {/*     }} */}
          {/*   /> */}
          {/* </AnimatedButton> */}
        </Box>
      )}
    </Box>
  );
}

export default AddMediaTray;
